/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy.reducer';

export const PharmacyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyEntity = useAppSelector(state => state.pharmacy.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacy.detail.title">Pharmacy</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacy.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.pharmacy.name">Name</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.name}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.pharmacy.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.pharmacy.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.createdBy}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacy.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacy.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacy.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacy.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacy.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.cursor}</dd>
          <dt>
            <span id="registrationCode">
              <Translate contentKey="tinyMedicRestApp.pharmacy.registrationCode">Registration Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.registrationCode}</dd>
          <dt>
            <span id="registrationAuth">
              <Translate contentKey="tinyMedicRestApp.pharmacy.registrationAuth">Registration Auth</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.registrationAuth}</dd>
          <dt>
            <span id="registrationState">
              <Translate contentKey="tinyMedicRestApp.pharmacy.registrationState">Registration State</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.registrationState}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.pharmacy.email">Email</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.email}</dd>
          <dt>
            <span id="returnInstructions">
              <Translate contentKey="tinyMedicRestApp.pharmacy.returnInstructions">Return Instructions</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.returnInstructions}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacy.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.taxCode}</dd>
          <dt>
            <span id="billPrefix">
              <Translate contentKey="tinyMedicRestApp.pharmacy.billPrefix">Bill Prefix</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.billPrefix}</dd>
          <dt>
            <span id="storeType">
              <Translate contentKey="tinyMedicRestApp.pharmacy.storeType">Store Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyEntity.storeType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacy.user">User</Translate>
          </dt>
          <dd>{pharmacyEntity.user ? pharmacyEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacy.contactCode">Contact Code</Translate>
          </dt>
          <dd>{pharmacyEntity.contactCode ? pharmacyEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy/${pharmacyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyDetail;
